import { AxiosError } from 'axios'

type StartWorkErrorBody = {
  error?: string
  message?: string
  meta?: { openType?: 'appointment' | 'task'; openPhase?: string | null } | null
}

/**
 * German messages for everything the start endpoints can throw, for both models.
 * ANOTHER_ITEM_IN_PROGRESS is shared wire vocabulary; the *_NOT_FOUND/_FORBIDDEN/_UNASSIGNED
 * codes are per-model but map to the same user-facing sentences.
 */
export function getStartWorkErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as StartWorkErrorBody | undefined
    switch (data?.error) {
      case 'TASK_NOT_FOUND':
        return 'Aufgabe nicht gefunden.'
      case 'APPOINTMENT_NOT_FOUND':
        return 'Termin nicht gefunden.'
      case 'TASK_FORBIDDEN':
        return 'Kein Zugriff auf diese Aufgabe.'
      case 'TASK_UNASSIGNED':
        return 'Die Aufgabe ist keinem Techniker zugewiesen.'
      case 'TRAVEL_NOT_STARTED':
        return 'Die Anfahrt wurde noch nicht gestartet. Bitte zuerst „Anfahrt starten" tippen.'
      case 'DEPARTURE_NOT_PENDING':
        return 'Für diesen Eintrag ist keine Abfahrt offen.'
      case 'WORK_PHASE_CONFLICT':
        return 'Diese Aktion ist im aktuellen Status nicht möglich. Bitte Seite aktualisieren.'
      case 'ANOTHER_ITEM_IN_PROGRESS': {
        const noun = data.meta?.openType === 'appointment' ? 'Ein anderer Termin' : 'Eine andere Aufgabe'
        return data.meta?.openPhase === 'ABFAHRT'
          ? `${noun} hat noch eine offene Abfahrt. Bitte zuerst „Abfahrt beenden".`
          : `${noun} ist bereits in Bearbeitung. Bitte zuerst abschließen.`
      }
    }
    if (error.response && error.response.status >= 500) {
      return 'Interner Serverfehler. Bitte später erneut versuchen.'
    }
  }
  return 'Arbeit konnte nicht gestartet werden. Bitte erneut versuchen.'
}
